var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHugcareHeartIconGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_944_5639)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 40C0 17.9086 17.9086 0 40 0C62.0914 0 80 17.9086 80 40C80 62.0914 62.0914 80 40 80C17.9086 80 0 62.0914 0 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2327 30.3133C34.5509 21.7224 25.3327 21.0406 20.3418 25.2133C15.3509 29.3861 14.9691 37.8952 19.6873 42.6133L38.2327 61.1588",
    stroke: "#51C671",
    strokeWidth: 2.94545,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3707 30.4759C42.0798 21.9123 51.2434 21.1759 56.1798 25.2941C59.3161 27.9396 60.5979 32.5486 59.1252 36.7214M38.207 61.1577L46.6888 52.6759",
    stroke: "#51C671",
    strokeWidth: 2.94545,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0156 47.5493L55.252 52.922L66.2156 41.6311",
    stroke: "#51C671",
    strokeWidth: 2.94545,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.81818 40C1.81818 18.9128 18.9128 1.81818 40 1.81818C61.0872 1.81818 78.1818 18.9128 78.1818 40C78.1818 61.0872 61.0872 78.1818 40 78.1818C18.9128 78.1818 1.81818 61.0872 1.81818 40Z",
    stroke: "#51C671",
    strokeWidth: 3.63636
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_944_5639"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 40C0 17.9086 17.9086 0 40 0C62.0914 0 80 17.9086 80 40C80 62.0914 62.0914 80 40 80C17.9086 80 0 62.0914 0 40Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHugcareHeartIconGreen);
export default __webpack_public_path__ + "static/media/hugcare-heartIconGreen.add3da8809d8192089d2675a4f74c6c2.svg";
export { ForwardRef as ReactComponent };